'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/square/FourSquares.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var FourSquares = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.75 3.75H10.25V10.25H3.75V3.75Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.75 3.75H20.25V10.25H13.75V3.75Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.75 13.75H10.25V20.25H3.75V13.75Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.75 13.75H20.25V20.25H13.75V13.75Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  })
);

export {
  FourSquares
};
//# sourceMappingURL=chunk-UA4CF2FC.mjs.map